import React from "react";
import Icon from "./icon";
import classNames from "classnames";

const QuantitySelector = ({ count, toggleCountQuantity, handleChangeCount }) => {
  return (
    <div className="quantity-selector">
      <div role="group" className="quantity-selector__wrapper">
        <button
          className={classNames(
            "quantity-selector__button",
            count < 2 && "quantity-selector__button--disabled"
          )}
          type="button"
          disabled={count < 2}
          onClick={toggleCountQuantity}
        >
          <Icon className="storybook" color="black" name="symbols-minus" />
        </button>
        <div className="quantity-selector__textfield">
          <input
            aria-invalid="false"
            type="text"
            className="quantity-selector__textfield-input"
            readOnly="readonly"
            value={count}
            onChange={handleChangeCount}
          ></input>
        </div>
        <button
          className="quantity-selector__button quantity-selector__button--right"
          type="button"
          onClick={() => toggleCountQuantity("increment")}
        >
          <Icon className="storybook" color="black" name="symbols-plus" />
        </button>
      </div>
    </div>
  );
};

export default QuantitySelector;
